import {
  AutoComplete,
  ReadOnly,
  useDataProvider,
  useEntityPermission,
} from '@ui-framework/index';
import { observer } from 'mobx-react';
import { useEffect, useState, forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';

const UserRoleSelect = forwardRef(
  ({ overwriteProps = {}, field, ...props }, ref) => {
    const nameKey = 'roleIdentifier';
    const valueKey = 'id';

    const [roles, setRoles] = useState([]);
    const provider =
      process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
    const { get, getApiUrl } = useDataProvider(provider);

    const { getValues } = useFormContext();
    const currentState = getValues(field?.name);

    const getRoles = async searchValue => {
      let searchParams = `companyType=${field.companyType}`;
      searchParams += searchValue ? `&roleIdentifier=${searchValue}` : '';

      const result = await get(
        `${getApiUrl()}/sxcl/v1/user-roles?${searchParams}`,
      );
      if (result.ok) {
        const roleOptions =
          result?.data?.data?.map(item => ({
            label: item[nameKey],
            value: item[valueKey],
          })) || [];
        return roleOptions;
      }
      return null;
    };

    const loadOptions = async (searchValue, callback) => {
      if (!searchValue) return [];
      const resultsData = await getRoles(searchValue);
      if (resultsData) {
        return callback(resultsData);
      }
      return callback([]);
    };

    const initialLoad = async () => {
      const result = await getRoles();
      setRoles(result);
    };

    useEffect(() => {
      initialLoad();
    }, []);

    const { isHidden, isReadOnly } = useEntityPermission();

    if (isReadOnly(props?.permission, currentState)) {
      return <ReadOnly name={props?.name}>{currentState?.label}</ReadOnly>;
    }

    if (isHidden(props?.permission)) {
      return (
        <input
          type="hidden"
          name={props?.name}
          value={currentState?.value || ''}
        />
      );
    }

    return (
      <AutoComplete
        ref={ref}
        defaultOptions={roles}
        loadOptions={loadOptions}
        {...props}
        overwriteProps={overwriteProps}
        isClearable
      />
    );
  },
);

export default observer(UserRoleSelect);
